import { useAdmin } from "@/context/AdminContext";

/**
 * Returns the CSS fontFamily string for the currently selected logo/heading font.
 * Use this in style={{ fontFamily: headingFont }} on section headings.
 */
export function useLogoFont(): { fontFamily: string; style: React.CSSProperties } {
  const { getLogoFont } = useAdmin();
  const font = getLogoFont();
  return { fontFamily: font.fontFamily, style: font.style ?? {} };
}
